module.exports = __webpack_public_path__ + "static/media/rocket.7be2d1d9.svg";